module.exports = __webpack_public_path__ + "media/images/players/OGLETREE_ANDY-5184f54d3a0a43e99c3bbec6f774adad.png";